module.exports = __webpack_public_path__ + "img/pro-p-slider23.598c108e.png";